// extracted by mini-css-extract-plugin
export default {"title":"style_title__tclfF","description":"style_description__UTPNn","showMore":"style_showMore__NOoYx","part":"style_part__emZF2","main":"style_main__wOElY"};